
    import '/home/runner/work/GPT-Vis/GPT-Vis/docs/guide/customize-style.en.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-guide-customize-style-demo-en-0","docs-guide-customize-style-demo-en-1"],
  getter: () => import(/* webpackChunkName: "meta__docs__en" */'/home/runner/work/GPT-Vis/GPT-Vis/docs/guide/customize-style.en.md?type=demo')
};